export function StreamlinePlumpGameboyRemix(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
      {...props}
    >
      {}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.41 1.097A152 152 0 0 1 24 .5c5.729 0 10.474.314 13.59.597c3.296.3 5.954 2.778 6.282 6.17c.31 3.198.629 8.493.629 16.733s-.32 13.535-.629 16.735c-.328 3.39-2.986 5.869-6.282 6.168c-3.116.284-7.861.598-13.59.598a152 152 0 0 1-13.59-.598c-3.295-.3-5.953-2.778-6.281-6.169C3.819 37.536 3.5 32.241 3.5 24c0-8.24.32-13.535.629-16.734c.328-3.39 2.986-5.87 6.282-6.169M24 4.5c-5.585 0-10.207.306-13.227.58c-1.471.134-2.528 1.182-2.663 2.572C7.815 10.696 7.5 15.859 7.5 24s.315 13.304.61 16.35c.135 1.389 1.192 2.436 2.663 2.57c3.02.274 7.642.58 13.228.58s10.207-.306 13.227-.58c1.471-.134 2.528-1.181 2.663-2.57c.294-3.046.61-8.208.61-16.35s-.316-13.304-.61-16.348c-.135-1.39-1.192-2.438-2.663-2.571C34.208 4.806 29.586 4.5 24 4.5m0 3.363c-4.073 0-7.412.14-9.507.259c-1.67.094-3.108 1.212-3.33 2.95c-.172 1.336-.321 3.299-.321 6.087s.15 4.751.32 6.087c.223 1.738 1.66 2.855 3.331 2.95c2.095.118 5.434.258 9.507.258s7.412-.14 9.507-.258c1.67-.095 3.108-1.212 3.33-2.95c.172-1.336.321-3.3.321-6.087s-.15-4.751-.32-6.087c-.223-1.738-1.66-2.856-3.331-2.95A171 171 0 0 0 24 7.863m-5.775 24.805a2 2 0 1 0-4 0v.914h-.904a2 2 0 0 0 0 4h.904v.912a2 2 0 1 0 4 0v-.912h.9a2 2 0 1 0 0-4h-.9zm9.642 2.913c0-2.438 1.97-4.42 4.408-4.42a4.414 4.414 0 0 1 4.408 4.42c0 2.438-1.97 4.42-4.408 4.42s-4.408-1.982-4.408-4.42"
        clipRule="evenodd"
      />
    </svg>
  );
}
